import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.revision, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_ALL_REVISIONS}_SUCCESS`: {
      return {
        ...state,
        [action.payload.problemSlug]: action.payload.data,
      };
    }
    default:
      return state;
  }
};
